import { useCallback } from 'react';
import styled from 'styled-components';
import { Chip } from '@mui/material';
import { componentToken } from '../../style/utils';

const StyledChip = styled(Chip)<{ $selected?: boolean }>`
  padding: ${componentToken('chip.quickFilter.padding')};
  margin-right: ${componentToken('chip.quickFilter.marginRight')};
  color: ${({ theme, $selected }) =>
    $selected
      ? theme.tokens.components.chip.quickFilter.selectedColor
      : theme.tokens.components.chip.quickFilter.color};
  background-color: ${({ theme, $selected }) =>
    $selected
      ? theme.tokens.components.chip.quickFilter.selectedBackground
      : theme.tokens.components.chip.quickFilter.background};

  :hover {
    background-color: ${({ theme, $selected }) =>
      $selected
        ? theme.tokens.components.chip.quickFilter.selectedHoverBackground
        : theme.tokens.components.chip.quickFilter.hoverBackground};
  }
`;

type Props = {
  label: React.ReactNode;
  value: string;
  filter: string;
  onClick?: (v: string) => void;
  disabled?: boolean;
};

const QuickFilterChip = ({
  label,
  value,
  filter,
  onClick,
  disabled,
}: Props) => {
  const handleClick = useCallback(() => onClick?.(value), [value, onClick]);

  return (
    <StyledChip
      label={label}
      onClick={handleClick}
      variant={filter === value ? 'filled' : 'outlined'}
      $selected={filter === value}
      size="small"
      disabled={disabled}
    />
  );
};

export default QuickFilterChip;
